<template>
  <range
    class="pagoda-number-range"
    :range-start-focus="rangeStartFocus"
    :range-end-focus="rangeEndFocus"
    :range-separator="rangeSeparator"
    :clearable="clearable"
    @clear="$emit('input', [])"
  >
    <el-input
      slot="range-start"
      :value="value[0]"
      :placeholder="startPlaceholder"
      @input="$emit('input', [arguments[0], value[1]])"
      @focus="rangeStartFocus = true"
      @blur="rangeStartFocus = false"
      @before-input="handleBeforeInput"
    ></el-input>
    <el-input
      slot="range-end"
      :value="value[1]"
      :placeholder="endPlaceholder"
      @focus="rangeEndFocus = true"
      @blur="rangeEndFocus = false"
      @input="$emit('input', [value[0], arguments[0]])"
      @before-input="handleBeforeInput"
    ></el-input>
  </range>
</template>

<script>
  import {
    getEmptyArray
  } from "../../utils"
  import Range from './range'

  export default {
    name: 'NumberRange',
    components: {
      Range
    },
    props: {
      value: {
        type: null,
        default: getEmptyArray
      },
      rangeSeparator: String,
      startPlaceholder: {
        type: String,
        default: '最小值'
      },
      endPlaceholder: {
        type: String,
        default: '最大值'
      },
      clearable: {
        type: Boolean,
        default: true
      }
    },
    data () {
      return {
        rangeStartFocus: false,
        rangeEndFocus: false
      }
    },
    methods: {
      handleBeforeInput (setValue, val) {
        // 限制用户只能输入数字
        setValue(val.replace(/[^\d]/g,''))
      }
    }
  }
</script>
